import React, { useEffect, useState } from 'react';
import { Wifi, ExternalLink } from 'lucide-react';
import { getEsim } from '@/lib/api';

export default function ESIMCard({ countryCode }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!countryCode) { setLoading(false); return; }
    let alive = true;
    setLoading(true);
    getEsim(countryCode).then(d => alive && setData(d)).catch(() => alive && setData(null)).finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [countryCode]);

  if (loading) return <div className="puvio-card p-5 gt-skeleton h-24" data-testid="esim-card-skeleton" />;
  if (!data || !data.available) return null;

  return (
    <div className="puvio-card p-5" data-testid="esim-card">
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-2xl bg-[#C4FF3D] flex items-center justify-center shrink-0 shadow-[0_4px_14px_rgba(196,255,61,0.5)]">
          <Wifi className="w-5 h-5 text-[#15291C]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-[10.5px] uppercase tracking-[0.22em] text-[#15291C]">eSIM · Data</p>
          <div className="flex items-baseline gap-2 mt-0.5">
            <p className="font-display text-lg font-bold text-[#0F1A13]" data-testid="esim-plan">{data.plan}</p>
            <span className="text-[12px] text-[#7A8A80]">· {data.provider}</span>
          </div>
          <div className="mt-1.5 flex items-center gap-3">
            <span className="gt-pill gt-pill-accent text-[11.5px]">{data.data_gb} GB</span>
            <span className="gt-pill gt-pill-dark text-[11.5px]">${data.price_usd} / 7d</span>
          </div>
        </div>
      </div>
      <p className="text-[12.5px] text-[#4A5A50] mt-3 leading-relaxed">
        {data.tip}
      </p>
      <a
        href={`https://www.airalo.com/?search=${encodeURIComponent(data.plan)}`}
        target="_blank" rel="noreferrer"
        className="mt-3 inline-flex items-center gap-1.5 text-[12px] font-bold text-[#15291C] hover:underline gt-focus"
        data-testid="esim-link"
      >
        Compare on Airalo <ExternalLink className="w-3 h-3" />
      </a>
    </div>
  );
}
